<template>
  <!-- Warning icon shown next to a country field whose value is an inactive
       country (locked applications only). Clicking it opens the message. -->
  <el-popover v-if="show" placement="right" trigger="click" width="280">
    <div class="inactive-country-message">
      <i class="el-icon-warning"></i>
      <span>{{ $t('inactive_country_warning') }}</span>
    </div>
    <i
      slot="reference"
      class="el-icon-warning inactive-country-icon"
      role="button"
      tabindex="0"
      :aria-label="$t('inactive_country_warning')"
    ></i>
  </el-popover>
</template>

<script>
export default {
  name: 'InactiveCountryWarning',
  props: {
    show: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss">
// Not scoped: the classes are applied by the parent components on their selects.
$inactive-country-bg: #fdf6ec;
$inactive-country-border: #e6a23c;
$inactive-country-text: #a35200; // ~5.6:1 contrast on white (WCAG AA)

.inactive-country-icon {
  margin-left: 6px;
  font-size: 18px;
  color: $inactive-country-text;
  cursor: pointer;
  vertical-align: middle;
}

.inactive-country-message {
  display: flex;
  align-items: flex-start;
  color: $inactive-country-text;
  word-break: normal;
  text-align: left;
  i {
    margin-right: 8px;
    font-size: 18px;
  }
}

// Highlights the select itself; overrides the grey style of disabled inputs.
.el-select.country-inactive .el-input .el-input__inner {
  background-color: $inactive-country-bg;
  border-color: $inactive-country-border;
  color: $inactive-country-text;
  font-weight: 600;
}

// Full-name line shown under the select for long country names.
.country-inactive-text {
  color: $inactive-country-text;
  font-weight: 600;
}
</style>
